import moment from 'moment'

const localeMoment = (date: string, inputFormat?: string): moment.Moment => {
  const dt = moment(date, inputFormat)
  return dt.clone().add(dt.utcOffset())
}

export {
  localeMoment
}
